import React from 'react';
import { Asset, AssetType } from './types';
import PlayMediaSVG from 'shared/components/svg/PlayMediaSVG';
import FilePDFSVG from 'shared/components/svg/FilePDFSVG';
import FileWithTextSVG from 'shared/components/svg/FileWithTextSVG';
import FileWordDocSVG from 'shared/components/svg/FileWordDocSVG';
import FileExcelSVG from 'shared/components/svg/FileExcelSVG';
import FileSVG from 'shared/components/svg/FileSVG';
import QuestionMarkCircleSVG from 'shared/components/svg/QuestionMarkCircleSVG';

interface AssetDownloadIconProps {
	asset: Asset;
	assetIconClasses?: string;
}

/**
 * Icon for an asset based on its file type.
 */
export default function AssetIcon(props: AssetDownloadIconProps) {
	const { asset, assetIconClasses } = props;

	if (asset.assetType === AssetType.Media || asset.assetType === AssetType.YouTube) {
		return <PlayMediaSVG color="#383735" className={assetIconClasses} />;
	} else if (asset.assetType === AssetType.Document) {
		const fileExtension = asset.assetUrl.split('.').pop();

		switch (fileExtension) {
			case 'pdf':
				return <FilePDFSVG className={assetIconClasses} />;
			case 'txt':
			case 'html':
			case 'htm':
			case 'xml':
				return <FileWithTextSVG className={assetIconClasses} />;
			case 'docx':
			case 'doc':
			case 'docm':
			case 'dot':
			case 'dotm':
			case 'dotx':
				return <FileWordDocSVG className={assetIconClasses} />;
			case 'csv':
			case 'xls':
			case 'xlsx':
			case 'xlsb':
			case 'xlsm':
			case 'xlt':
			case 'xltm':
			case 'xltx':
			case 'xlw':
				return <FileExcelSVG className={assetIconClasses} />;
			default:
				return <FileSVG className={assetIconClasses} />;
		}
	} else {
		return <QuestionMarkCircleSVG className={assetIconClasses} />;
	}
}
